import * as t from 'io-ts';
import { issuePhoto } from '@/services/api/resources/issue/v2';
import { IssueStatus } from '@/entities/todo';
import { id } from '@/services/api';
import { IssuePriority } from '@/entities/issue';
import { DateFromUnixTime } from 'io-ts-types/DateFromUnixTime';

export const data = t.type({
  id,
  title: t.string,
  description: t.union([t.string, t.null]),
  associateAssignees: t.array(t.string),
  status: t.union([
    t.literal(IssueStatus.Pending),
    t.literal(IssueStatus.InProgress),
    t.literal(IssueStatus.Done),
    t.literal(IssueStatus.CantDo),
  ]),
  entityItem: t.union([t.type({ title: t.string }), t.null]),
  priority: t.union([
    //remove Low here when we sure that it is no more in DB
    t.literal(IssuePriority.Low),
    t.literal(IssuePriority.Normal),
    t.literal(IssuePriority.High),
  ]),
  suggestedCorrectiveAction: t.union([t.string, t.null]),
  performedCorrectiveAction: t.union([t.string, t.null]),
  deadline: t.union([DateFromUnixTime, t.null]),
  sensorsLastMeasurement: t.union([t.string, t.null]),
  photos: t.array(issuePhoto),
  locale: t.string,
});

export const detailCodec = t.type({
  data,
});

export const formCodec = t.type({
  status: t.number,
});
